export default __webpack_public_path__ + "static/media/typing.7b908106.gif";